/* Ninja Transfers — Ready-To-Press products are never purchasable
 * ---------------------------------------------------------------------------
 * RTP design pages are PICKERS: the visitor chooses artwork and is handed off
 * to the DTF / UV by-size builders, which is where the actual purchase happens.
 * The RTP products themselves still exist in Shopify as fully sellable items
 * (real prices, tracked inventory), so they remain reachable through paths the
 * theme doesn't control — cart permalinks (/cart/<variant>:1), quick-add tiles,
 * upsell apps, the Storefront API, and stale carts. At least one order slipped
 * through that way (Justin 7-27).
 *
 * WHY THIS SHAPE: the RTP product template renders no add-to-cart form at all,
 * so gating that template would accomplish nothing — the adds don't originate
 * there. Instead this works off the CART, which every path must go through:
 * whenever the cart changes, any line whose product_type is "Ready To Press"
 * is removed. Entry-point agnostic by construction.
 *
 * Matching is by product_type (from /cart.js), NOT variant ids — new RTP
 * designs are added constantly and would never be covered by a hardcoded list.
 *
 * ⚠ This is a client-side guard, not a guarantee. Anything that adds and
 * checks out without ever loading a page (headless / direct API) is untouched.
 * The server-side lock is a Cart & Checkout Validation Function — deliberately
 * deferred; see the 7-27 thread.
 *
 * Loaded site-wide from layout/theme.liquid (NOT template-gated, on purpose).
 * Note sections/main-product.liquid is ~388KB and over Shopify's 256KB push
 * limit — it can no longer be edited via the CLI, which is the other reason
 * this lives in its own asset.
 * ========================================================================== */

(function () {
  'use strict';

  if (window.__ntRtpNoCart) return;
  window.__ntRtpNoCart = true;

  var RTP_TYPE = /^ready\s*to\s*press$/i;
  var ADD_RE = /\/cart\/(add|change|update)(\.js)?(\?|$)/i;
  var sweeping = false;
  var queued = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Remove every Ready-To-Press line from the cart. Uses /cart/change.js with
     the line KEY (not index) so concurrent edits can't remove the wrong row. */
  function sweep() {
    if (sweeping) { queued = true; return; }
    sweeping = true;
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bad = (cart.items || []).filter(function (li) {
          return RTP_TYPE.test(String(li.product_type || '').trim());
        });
        if (!bad.length) return null;
        console.warn('[rtp-no-cart] removing ' + bad.length +
          ' ready-to-press line(s) — these are design pickers, not products');
        /* Sequential: each /cart/change response is the new cart state. */
        return bad.reduce(function (chain, li) {
          return chain.then(function () {
            return fetch(root() + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: li.key, quantity: 0 })
            });
          });
        }, Promise.resolve());
      })
      .catch(function (e) { console.warn('[rtp-no-cart] sweep failed', e); })
      .then(function () {
        sweeping = false;
        if (queued) { queued = false; setTimeout(sweep, 150); }
      });
  }

  var debounce = null;
  function scheduleSweep() {
    clearTimeout(debounce);
    debounce = setTimeout(sweep, 250);
  }

  /* 1) Any cart mutation through fetch */
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function () {
      var input = arguments[0];
      var url = (input && input.url) ? input.url : String(input || '');
      var p = of.apply(this, arguments);
      try { if (ADD_RE.test(url)) p.then(function () { scheduleSweep(); }, function () {}); } catch (e) {}
      return p;
    };
  }

  /* 2) …and through XHR */
  var oo = XMLHttpRequest.prototype.open;
  var os = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__rtpUrl = u; return oo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    try {
      if (xhr.__rtpUrl && ADD_RE.test(xhr.__rtpUrl)) {
        xhr.addEventListener('load', function () { scheduleSweep(); });
      }
    } catch (e) {}
    return os.apply(this, arguments);
  };

  /* 3) Full page loads that can carry a fresh add: the cart + checkout-bound
     pages, and cart permalinks (/cart/<variant>:1 lands on /cart). */
  if (/^\/cart($|\/|\?)/.test(location.pathname) || /\/cart$/.test(location.pathname)) {
    sweep();
  }
})();
